import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { RENDERER_REQUEST, rendererError, rendererSuccess } from '../actions'
import config from '../config'
import { authHeaderSelector } from '../selectors'
import { Middleware } from '../store'
import { RendererError } from '../types'
import { datadogLogs } from '@datadog/browser-logs'

export const rendererMiddleware: Middleware = (store) => (next) => (action) => {
  next(action)

  if (action.type.indexOf(RENDERER_REQUEST) > 0) {
    const { url, method, feature, params, responseType } = action.meta

    let fullUrl: string
    let data: any
    if (url.indexOf('http') === 0) {
      fullUrl = url
      data = action.payload
    } else {
      fullUrl = config.renderer + url
      data = action.payload ? JSON.stringify(action.payload) : null
    }

    const headers = authHeaderSelector(store.getState())
    if (method === 'POST' || method === 'PUT') {
      headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }

    const reqConfig: AxiosRequestConfig = {
      url: fullUrl,
      method,
      headers: headers,
      data,
      params,
      responseType,
    }

    axios(reqConfig)
      .then((response: AxiosResponse) => {
        if (response.status > 299) {
          store.dispatch(rendererError(response.data, feature))
        } else {
          store.dispatch(rendererSuccess(response.data, feature))
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return undefined
        }

        datadogLogs.logger.error('RendererMiddleware error', {
          error: error,
          source: 'rendererMiddleware',
          reqType: feature,
          url: fullUrl,
          method: method,
        })
        // Sentry.withScope(function (scope) {
        //   setSentryErrorData(scope, error)
        //   scope.setTag('source', 'rendererMiddleware')
        //   scope.setTag('reqType', feature)
        //   scope.setContext('request', {
        //     url: fullUrl,
        //     method: method,
        //   })
        //   Sentry.captureException(error)
        // })
        console.error('RENDERER ERROR: ', error)
        if (error?.response?.data) {
          store.dispatch(rendererError(error.response.data, feature))
        } else {
          store.dispatch(rendererError((error.response as unknown) as RendererError, feature))
        }
      })
  }
}
